import cx from 'classnames';
import { t } from 'i18next';
import { asset } from '../../../services/assetResolverService';
import { LinkSharingAd, TLinkSharingSpecGuideAdProps } from '../linkSharingAd';
import { PropsWithChildren } from 'react';

type TLinkSharingVariantProps = PropsWithChildren<TLinkSharingSpecGuideAdProps & { guideUrl: string }>;

export const LinkSharingSpecGuideAdVariant2 = (props: TLinkSharingVariantProps) => {
  return (
    <LinkSharingAd
      url={props.guideUrl}
      tag="icy-veins-guide-v2"
      className={cx('iv-callout-button--v2', props.className)}
    >
      <span className="iv-callout-button__logo" aria-hidden="true">
        <img src={asset('/images/site/partners/iv_text_only.svg')} alt="Icy Veins" />
      </span>
      <span className={`iv-callout-button__title class-color--${props.class}`}>
        {t('collabs:class-spec-guide', {
          classAndSpec: t('common:class-spec', {
            class: t(`game:classes.${props.class}.name`),
            spec: t(`game:specs.${props.class}.${props.spec}.name`)
          })
        })}
      </span>
      <span className="iv-callout-button__imprint">
        <img src={asset('/images/site/partners/iv_imprint_only.svg')} alt="" />
      </span>
    </LinkSharingAd>
  );
};
